module.exports = __webpack_public_path__ + "img/avatar-placeholder.9d046a16.png";